import { Component, ElementRef, EventEmitter, HostListener, Input, Output, ViewChild } from "@angular/core";
import { Order } from "../../../objects/orders/order";
import { NgForm } from "@angular/forms";
import { ModalDirective } from "ngx-bootstrap";
import * as ps from "perfect-scrollbar";
import { CBP7501, LineInputs } from "../../../objects/documents/CBP7501";
import { DocumentService } from "../../../services/documentService";
import { FirstBlock7501Component } from "./document-blocks/first-block-7501.component";
import { TableBlock7501Component } from "./document-blocks/table-block-7501.component";
import { ThirdBlock7501Component } from "./document-blocks/third-block-7501.component";
import { DeclarationBlock7501Component } from "./document-blocks/declaration-block-7501.component";
import { PropertyHelper } from "../../../common/helpers/propertyHelper";
import { RequestMethod, RequestOptions } from "@angular/http";
import { BaseResponse } from "../../../objects/common/baseResponse";
import { BaseApi } from "../../../services/baseService";
import { ScrollHelper } from "../../../common/helpers/scrollHelper";
import { ScreenHelper } from "../../../common/helpers/screenHelper";

@Component({
    selector: 'document-7501',
    templateUrl: 'document-7501.component.html',
    moduleId: module.id.toString()
})
export class Document7501Component {
    @ViewChild('documentModal')
    public documentModal: ModalDirective;

    @ViewChild("documentForm")
    public documentForm: NgForm;

    @ViewChild('documentModalRef')
    public documentModalRef: ElementRef;

    @Input()
    public order: Order;

    @Output()
    public documentModified: EventEmitter<CBP7501> = new EventEmitter<CBP7501>();

    @ViewChild(FirstBlock7501Component)
    public firstBlock7501Component: FirstBlock7501Component;

    @ViewChild(TableBlock7501Component)
    public tableBlock7501Component: TableBlock7501Component;

    @ViewChild(ThirdBlock7501Component)
    public thirdBlock7501Component: ThirdBlock7501Component;

    @ViewChild(DeclarationBlock7501Component)
    public declarationBlock7501Component: DeclarationBlock7501Component;

    @ViewChild('saveBtn')
    public saveBtn: ElementRef;

    @ViewChild('closeBtn')
    public closeBtn: ElementRef;

    public processing: boolean = false;

    public document: CBP7501 = new CBP7501();

    public isFormSubmitted: boolean = false;

    public constructor(private documentService: DocumentService) {

    }


    public onScroll(scrollY: any): void {
            ScrollHelper.stickyElementOnScroll(scrollY, [this.saveBtn.nativeElement, this.closeBtn.nativeElement], 150);
    };

    public show(document: CBP7501 = new CBP7501()): void {
        this.document = document;

        if (this.document.TableLineInputs.length == 0 || this.document.TableLineInputs == null)
            this.document.TableLineInputs.push(new LineInputs());

        this.documentModal.show();
    }

    public isDocumentValid(): boolean {
        if (!this.firstBlock7501Component || !this.tableBlock7501Component ||
            !this.thirdBlock7501Component || !this.declarationBlock7501Component) {
            return false;
        }
        return (this.firstBlock7501Component.isFormValid() && this.tableBlock7501Component.isFormValid() &&
            this.thirdBlock7501Component.isFormValid() && this.declarationBlock7501Component.isFormValid());

    }

    public closeDocumentModal(hideModal: boolean): void {
        this.firstBlock7501Component.firstBlockForm.resetForm();
        this.tableBlock7501Component.tableBlockForm.resetForm();
        this.thirdBlock7501Component.thirdBlockForm.resetForm();
        this.declarationBlock7501Component.declarationForm.resetForm();

        this.isFormSubmitted = false;

        if (hideModal)
            this.documentModal.hide()
    }

    public save(): void {
        this.firstBlock7501Component.submitFormAndValidity();
        this.tableBlock7501Component.submitFormAndValidity();
        this.thirdBlock7501Component.submitFormAndValidity();
        this.declarationBlock7501Component.submitFormAndValidity();

        if (!this.isDocumentValid()) {
            this.isFormSubmitted = true;
            return;
        }

        this.document.OrderId = this.order.Id;
        this.document.Name = 'CBP7501';

        this.documentService.save<CBP7501>(this.document, 'CBP7501').then((resp: any) => {

                this.document = resp.Data;

                let isValid = PropertyHelper.isPropsValid(resp.Data);

                for (let table of this.document.TableLineInputs) {
                    if (!PropertyHelper.isPropsValid(table)) {
                        isValid = false;
                        break;
                    }
                }

                if (isValid) {
                    this.documentModified.emit(resp);
                    this.closeDocumentModal(true);
                }
            }
        );
    }

    public ngOnInit(): void {
        ps.initialize(this.documentModalRef.nativeElement);
    }

}


// WEBPACK FOOTER //
// ./app/components/export-documents/cbp-7501/document-7501.component.ts